import { Link } from "react-router-dom"

function MishaafLogo() {
  return (
    <div>
       <div className="rounded-[12px] " >
            <div className="flex justify-center mt-[15px] mb-[15px] ">
              <div className=" w-[37%] h-[13rem]  rounded-[12px] border-[1px] flex justify-center items-center border-gray-300 ">
             <div className="  flex justify-center bg-black  h-[12rem] w-[96%] rounded-[12px] " >
             <Link to="/">
                <img
                  src="/assets/images/Mishaaf-icon.jpeg"
                  alt="brand-logo"
                  className="h-[12rem]"
                  />
              </Link>
             </div>
                  </div>
                  </div>
            </div>
    </div>
  )
}

export default MishaafLogo
